export const INVALID_SESSION_RESPONSE_MESSAGES = [
    'You should specify id token for this request!',
    'You are not authorized to perform this action!',
    'Session is invalid. Please re-enter your credentials.',
    'Session ended due to inactivity. Please re-enter your credentials.',
    'Session invalid or blocked due to inactivity. Please re-enter your credentials',
    'The Firebase ID token has been revoked.',
];
